<template>
 
  <ion-content >
  <div id="container"  style="margin-left: 24px;margin-right: 24px;">
    <ion-row>
        <ion-col/>
        <ion-col/>
        <ion-col>
          <button 
            type="button" 
            @click="closeModal()" 
            style="margin-left: 67%;margin-top: 6px; border-radius: 10px;background: #000;"
          >
            <ion-icon :icon="close"></ion-icon> 
          </button>
        </ion-col>
      </ion-row>
    <ion-title> Subir Firma </ion-title>
    <signature :documento="documento"></signature>
    <ion-form>
     
    </ion-form>
  </div>
</ion-content>

</template>

<script>

import { defineComponent } from 'vue';
import { close } from 'ionicons/icons';
import { modalController } from '@ionic/vue';
import signature from './signature'
import axios from 'axios'
import toast from '@/plugins/toast'

export default defineComponent({
  name: 'AgregarColaborador',
  props : ['documento'],
  components :{signature},
  setup() {
    return { close }
  },
  data(){
    return{
      id : null,
      user: null,
      email: null,
      password: null,
    }
  },
  mounted(){
    
  },
  methods:{
    async closeModal() {
      const modal = await modalController
      return modal.dismiss();
    },
    async editColaborador(){
      var loading = await toast.showLoading()

      await loading.present();

      axios.post('/api/users/'+this.id,{
        user_name : this.user,
        email : this.email,
        password : this.password,
        password_confirmation : this.password_confirmation
      })
      .then(data =>{
        console.log(data)
         loading.dismiss()
        this.$toast.openToast("Modificacion de colaborador exitosa","success")
      }).catch(err =>{
         loading.dismiss()
        console.log(err)
      })
    }
  }
});
</script>

<style scoped>

ion-label {
  font-weight: bold;
}

ion-input {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
}

ion-button {
  width: auto;
  --border-radius: 5px;
  height: 35px;
  text-transform: none;
}
</style>
